import {DatePipe} from '@angular/common';
import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
// eslint-disable-next-line no-restricted-syntax
import * as moment from 'moment-timezone';

@Pipe({
  name: 'date',
})
export class DatePipeTz extends DatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) locale: string) {
    super(locale);
  }
  transform(value: any, format?: string, timezone: string = 'America/New_York', locale?: string): any {
    return super.transform(value, format, timezone !== null ? moment.tz(value, timezone).format('z') : undefined, locale);
  }
}
